// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"Slider_sliderContainer__Pq4yp"};